import React, {FC} from 'react'
import s from './index.module.scss'
import Logo from '../../../../img/brand-new-logo.svg'
import icon from "./icon.svg"
import date from "./date.svg"
import marker from "./marker.svg"

type Props = {
  renderForm: () => any
}
const isMobile = window.innerWidth < 1004
const Register: FC<Props> = ({renderForm}) => {
  return (
    <>
      <div className={s.cover}>
        <div id='form' className={s.root}>
          <div className={s.logo}>
            <a target='_blank' rel="noopener noreferrer" href='https://flyxo.com'>
              <img src={Logo} alt='XO logo'/>
            </a>
          </div>
          <div className={s.content}>
            <div className={s.image}>
              <div className={s.title}>
                <h1>
                  <div>
                    Transformative Travel for Those Transforming Industries
                  </div>
                </h1>
                <h2>
                  Private Aviation Partner of{' '}
                  <img alt='' aria-hidden={true} className={s.icon} src={icon}/>
                </h2>
                <div className={s.date}>
                  <div className={s.calendar}>
                    <img alt='' aria-hidden={true} className={s.smallIcon} src={date}/>
                    <span>March 11–20</span>
                  </div>
                  <div className={s.marker}>
                    <img alt='' aria-hidden={true} className={s.smallIcon} src={marker}/>
                    <span>Austin, TX</span>
                  </div>
                </div>
              </div>
            </div>
            {!isMobile ? (
              <div className={s.form}>
                {renderForm()}
              </div>
            ) : null}
          </div>
        </ div>
      </div>
      {isMobile ? (
        <div className={s.form}>
          {renderForm()}
        </div>
      ) : null}
    </>
  )
}

export default Register
